import React from 'react'
import { Box } from '@mui/material';


const FooterReferencia = () => {

  const detalle = 'La radiación ultravioleta (rayos UVA/ UVB) del sol también llega a nosotros cuando el cielo está nuboso o cubierto, \n se refleja en distintas superficies (agua, arena, asfalto, entre otras) y no está relacionada con la temperatura. \n Una vez que el índice UV alcanza el nivel 3, debemos tomar medidas para cuidar nuestra salud.'

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        flewWrap: 'wrap',
        justifyContent: { xs: 'left', lg: 'space-evenly' },

        backgroundColor: 'primary.main',
        fontFamily: 'Roboto',
        width: '100%',
        maxWidth: 'calc(14rem * 5 - 2em)',
        height: 'auto',
        p: '1em'


      }}
    >
      <Box
        sx={{
          color: 'primary.contrastText',
          whiteSpace: 'pre-wrap',

        }}>
        <p>{detalle}</p>
      </Box>


      <Box
        sx={{
          maxWidth: '10rem',
          justifyContent: 'center',
          alignItems: 'center',

          display: { xs: 'none', lg: 'flex' },
          flexGrow: 1,
        }}
      >
        <img
          width={'100%'}
          height={'auto'}
          src={`${process.env.PUBLIC_URL}/assets/logo_inumet.png`} alt="Logo INUMET" />
      </Box>

    </Box>
  )
}

export default FooterReferencia
